import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { CascadeSelect } from "primereact/cascadeselect";
import { PlusIcon } from "primereact/icons/plus";
import { useNavigate, useLocation } from "react-router-dom";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";
import { TreeSelect } from "primereact/treeselect";
import Select from "react-select";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import { saveAs } from "file-saver";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setCandidateSidebarVisible } from "store/actions";
import { setJobSidebarVisible } from "store/actions";
import { setContactSidebarVisible } from "store/actions";
import { setCompanySidebarVisible } from "store/actions";

const AddMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [visibleRight, setVisibleRight] = useState(false);
  const [isCandidatesSidebarVisible, setIsCandidatesSidebarVisible] = useState(false);
  const [isContactsSidebarVisible, setIsContactsSidebarVisible] = useState(false);
  const [isCompaniesSidebarVisible, setIsCompaniesSidebarVisible] = useState(false);
  const [isAddsSidebarVisible, setIsAddsSidebarVisible] = useState(false);
  const [isExportDialogVisible, setIsExportDialogVisible] = useState(false);
  const [selectedAddMenu, setSelectedAddMenu] = useState(null);
  const SHOW_IMPORT = false;

  // Form states initialized to empty
  const [jobId, setJobId] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [experience, setExperience] = useState(null);
  const [jobLocation, setJobLocation] = useState(null);
  const [jobStartDate, setJobStartDate] = useState(null);
  const [jobEndDate, setJobEndDate] = useState(null);
  const [selectedPrimarySkills, setSelectedPrimarySkills] = useState([]);
  const [workplaceType, setWorkplaceType] = useState("");
  const [userIds, setUserIds] = useState("");
  const [selectedCategoryKey, setSelectedCategoryKey] = useState(null);
  const [selectedGroupKey, setSelectedGroupKey] = useState(null);
  const [description, setDescription] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [candidateCompany, setCandidateCompany] = useState("");
  const [selectedCity, setSelectedCity] = useState(null);
  const [availabilityDate, setAvailabilityDate] = useState(null);
  const [resumeAttachment, setResumeAttachment] = useState(null);
  const [relocation, setRelocation] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [website, setWebsite] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [address, setAddress] = useState("");
  const [yearFounded, setYearFounded] = useState(null);
  const [specialties, setSpecialties] = useState("");
  const [industry, setIndustry] = useState(null);
  const [companySize, setCompanySize] = useState(null);
  const [overview, setOverview] = useState("");
  const [street1, setStreet1] = useState("");
  const [street2, setStreet2] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedLabel, setSelectedLabel] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [relatedPerson, setRelatedPerson] = useState(null);
  const [typeInterviewval, setTypeInterviewval] = useState([]);
  const [typeInterviewcontact, setTypeInterviewcontact] = useState([]);
  const [allContacts, setAllContacts] = useState([]);
  const [totalRecordsContacts, setTotalRecordsContacts] = useState(0);
  const [filteredCandidates, setFilteredCandidates] = useState([]);

  // Sample data (for fallback or testing)
  const candidateData = [
    { firstName: "John", lastName: "Doe", email: "john.doe@example.com", phoneNumber: "1234567890", jobTitle: "Developer", company: "Tech Corp", city: "Hyderabad", availabilityDate: "2025-07-01", primarySkills: ["Java", "React"], relocation: true, isPrivate: false },
    { firstName: "Jane", lastName: "Smith", email: "jane.smith@example.com", phoneNumber: "0987654321", jobTitle: "Designer", company: "Design Inc", city: "Mumbai", availabilityDate: "2025-07-02", primarySkills: ["React"], relocation: false, isPrivate: true },
  ];

  const companyData = [
    { companyName: "Tech Corp", website: "www.techcorp.com", email: "contact@techcorp.com", phoneNumber: "1234567890", address: "123 Tech St, Hyderabad", yearFounded: "2010", specialties: "Software Development", industry: "Information Technology", companySize: "51-200 employees" },
    { companyName: "Design Inc", website: "www.designinc.com", email: "info@designinc.com", phoneNumber: "0987654321", address: "456 Design Ave, Mumbai", yearFounded: "2015", specialties: "UI/UX Design", industry: "Design", companySize: "11-50 employees" },
  ];

  // Options for dropdowns and selects
  const companyOptions = [
    { name: "Google", code: "GOO" },
    { name: "Microsoft", code: "MS" },
    { name: "Apple", code: "APL" },
    { name: "Amazon", code: "AMZ" },
    { name: "Facebook", code: "FB" },
  ];

  const personOptions = [
    { name: "Ram Mohan", role: "HR", code: "HR" },
    { name: "Sita Verma", role: "Manager", code: "MGR" },
    { name: "Amit Sharma", role: "Team Lead", code: "TL" },
    { name: "Ravi Kapoor", role: "CEO", code: "CEO" },
    { name: "Neha Patel", role: "Intern", code: "INT" },
  ];

  const jobLocations = [
    { name: "Hyderabad", code: "HYD" },
    { name: "Chennai", code: "CHN" },
    { name: "Mumbai", code: "MUM" },
    { name: "Bangalore", code: "BLR" },
    { name: "Delhi", code: "DEL" },
  ];

  const cityOptions = [
    { name: "Hyderabad", code: "HYD" },
    { name: "Chennai", code: "CHN" },
    { name: "Mumbai", code: "MUM" },
    { name: "Bangalore", code: "BLR" },
    { name: "Delhi", code: "DEL" },
  ];

  const skillsOptions = [
    { value: "java", label: "Java" },
    { value: "react", label: "React" },
    { value: "nodejs", label: "Node.js" },
  ];

  const categories = [
    {
      key: "0",
      label: "Skills",
      children: [
        {
          key: "0-0",
          label: "Frontend",
          children: [
            { key: "0-0-0", label: "React" },
            { key: "0-0-1", label: "Angular" },
            { key: "0-0-2", label: "Bootstrap" },
          ],
        },
        {
          key: "0-1",
          label: "Backend",
          children: [
            { key: "0-1-0", label: "Python" },
            { key: "0-1-1", label: "Java" },
            { key: "0-1-2", label: "C#" },
          ],
        },
      ],
    },
  ];

  const groups = [
    {
      key: "0",
      label: "Skills",
      children: [
        {
          key: "0-0",
          label: "Frontend",
          children: [
            { key: "0-0-0", label: "React" },
            { key: "0-0-1", label: "Angular" },
            { key: "0-0-2", label: "Bootstrap" },
          ],
        },
        {
          key: "0-1",
          label: "Backend",
          children: [
            { key: "0-1-0", label: "Python" },
            { key: "0-1-1", label: "Java" },
            { key: "0-1-2", label: "C#" },
          ],
        },
      ],
    },
  ];

  const industries = [
    { name: "Information Technology", code: "IT" },
    { name: "Healthcare", code: "HC" },
    { name: "Finance", code: "FN" },
    { name: "Manufacturing", code: "MN" },
    { name: "Retail", code: "RT" },
  ];

  const companySizes = [
    { name: "1-10 employees", code: "1-10" },
    { name: "11-50 employees", code: "11-50" },
    { name: "51-200 employees", code: "51-200" },
    { name: "201-500 employees", code: "201-500" },
    { name: "501-1000 employees", code: "501-1000" },
  ];

  const departmentOptions = [
    { name: "Account Finance Team", code: "HR" },
    { name: "SPG US Staffing", code: "FIN" },
    { name: "Vitel Development Team", code: "MKT" },
    { name: "Support Team", code: "ENG" },
    { name: "NOC Team", code: "SAL" },
  ];

  const addCities = [
    { name: "Hyderabad", code: "HYD" },
    { name: "Chennai", code: "CHN" },
    { name: "Mumbai", code: "MUM" },
    { name: "Bangalore", code: "BLR" },
    { name: "Delhi", code: "DEL" },
  ];

  const addStates = [
    { name: "Andhra Pradesh", code: "AP" },
    { name: "Telangana", code: "TG" },
    { name: "Tamil Nadu", code: "TN" },
    { name: "Karnataka", code: "KA" },
    { name: "Kerala", code: "KL" },
  ];

  const addCountries = [
    { name: "India", code: "IN" },
    { name: "United States", code: "US" },
    { name: "Canada", code: "CA" },
    { name: "Germany", code: "DE" },
    { name: "Australia", code: "AU" },
  ];

  const labels = [
    { name: "Work from Office", code: "WORK" },
    { name: "Work from Home", code: "HOME" },
    { name: "Work from Remote", code: "REMOTE" },
  ];
  const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));
  const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
  const [companyId, setCompanyId] = useState(intialcompanyId);
  // API calls
  const getCandidateList = async () => {
    try {
      const response = await axios.get(`/api/v1/candidates/?page=1&size=10&company_id=${companyId}`);
      if (response.data) {
        setFilteredCandidates(response.data.results);
      }
    } catch (error) {
      console.log("Error fetching candidates:", error);
    }
  };

  const getAllActiveContacts = async () => {
    try {
      const response = await axios.get(`/api/v1/contacts/?page=1&size=10&company_id=${companyId}`);
      const transformedData = response.data.results.map((contact) => ({
        name: contact.first_name,
        id: contact.id,
      }));
      setTypeInterviewcontact(transformedData);
      setAllContacts(response.data.results);
      setTotalRecordsContacts(response.data.count || 0);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };

  const getJobs = async () => {
    try {
      const response = await axios.get(`/api/v1/jobs/?page=1&size=10&company_id=${companyId}`);
      const transformedData = response.data.results.map((job) => ({
        name: job.job_title,
        id: job.job_id,
      }));
      setTypeInterviewval(transformedData);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };

  const getCompanies = async () => {
    try {
      const response = await axios.get(`/api/v1/company/?page=1&size=5&company_id=${companyId}`);
      return response.data.results;
    } catch (error) {
      console.error("Error fetching companies:", error);
      return [];
    }
  };

  useEffect(() => {
    getCandidateList();
    getAllActiveContacts();
    getJobs();
    getCompanies();
  }, []);

  // Function to convert data to CSV
  const convertToCSV = (data, headers) => {
    const headerRow = headers.join(",");
    if (!data || data.length === 0) {
      return headerRow; // Return only headers if data is empty
    }
    const rows = data.map((item) =>
      headers
        .map((header) => {
          const value = item[header] || "";
          return `"${String(value).replace(/"/g, '""')}"`;
        })
        .join(",")
    );
    return [headerRow, ...rows].join("\n");
  };

  // Export functions
  const exportCandidatesToCSV = async () => {
    try {
      const response = await axios.get(`/api/v1/all-candidates-for-export/`);
      const data = response.data.results || [];
      const headers = ["first_name", "last_name", "email", "mobile_phone", "job_title", "current_company", "status" ,"availability_date", "primary_skill_names", "relocation", "is_private"];
      const csvContent = convertToCSV(data, headers);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "candidates.csv");
    } catch (error) {
      console.error("Error exporting candidates:", error);
      const headers = ["first_name", "last_name", "email", "mobile_phone", "job_title", "current_company", "status" ,"availability_date", "primary_skill_names", "relocation", "is_private"];
      const csvContent = headers.join(",");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "candidates.csv");
    }
    setIsExportDialogVisible(false);
  };

  const exportJobsToCSV = async () => {
    try {
      const [jobsResponse, statusResponse] = await Promise.all([
        axios.get(`/api/v1/all-jobs-for-export/`),
        axios.get(`/api/v1/get-all-Job-status/`)
      ]);
      
      const data = jobsResponse.data.results || [];
      const statusMap = {};
      statusResponse.data.results?.forEach(status => {
        statusMap[status.id] = status.job_status;
      });
      
      const transformedData = data.map(job => ({
        ...job,
        status: statusMap[job.status] || job.status
      }));
      
      const headers = ["job_number", "job_title", "company_name", "hiring_manager_name", "required_experience" , "status" ,"location_name", "job_start_date", "job_end_date", "required_skill_names", "workplace_name"];
      const csvContent = convertToCSV(transformedData, headers);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "jobs.csv");
    } catch (error) {
      console.error("Error exporting jobs:", error);
      const headers = ["job_number", "job_title", "company_name", "hiring_manager_name", "required_experience", "status" ,"location_name", "job_start_date", "job_end_date", "required_skill_names", "workplace_name"];
      const csvContent = headers.join(",");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "jobs.csv");
    }
    setIsExportDialogVisible(false);
  };

  const exportCompaniesToCSV = async () => {
    try {
      const [companiesResponse, statusResponse] = await Promise.all([
        axios.get(`/api/v1/all-company-for-export/`),
        axios.get(`/api/v1/company-status/`)
      ]);
      
      const data = companiesResponse.data.results || [];
      const statusMap = {};
      statusResponse.data?.forEach(status => {
        statusMap[status.id] = status.company_status;
      });
      
      const transformedData = data.map(company => ({
        ...company,
        status: statusMap[company.status] || company.status
      }));
      
      const headers = [
        "company_name",
      "category_name",
      "groups_name",
      "industry_name",
      "created_by_name",
      "company_size",
      "status",
      "archived",
      "is_deleted",
      "created_at",
      "updated_at",
      "archived_at",
      "deleted_at",
      "description",
      "founded_year",
      "headquarters",
      "logo_url",
      "website",
      "linkedin_url",
      "twitter_url",
      "facebook_url",
      "x_url",
      "specialties",
      "company_email",
      "mobile_phone",
      "notes",
      "last_activity_type",
      "last_activity_date",
      "private",
      "street_address",
      "street_address_line_2",
      "pincode"
      ];
      const csvContent = convertToCSV(transformedData, headers);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "companies.csv");
    } catch (error) {
      console.error("Error exporting companies:", error);
      const headers = [
              "company_name",
      "category_name",
      "groups_name",
      "industry_name",
      "created_by_name",
      "company_size",
      "status",
      "archived",
      "is_deleted",
      "created_at",
      "updated_at",
      "archived_at",
      "deleted_at",
      "description",
      "founded_year",
      "headquarters",
      "logo_url",
      "website",
      "linkedin_url",
      "twitter_url",
      "facebook_url",
      "x_url",
      "specialties",
      "company_email",
      "mobile_phone",
      "notes",
      "last_activity_type",
      "last_activity_date",
      "private",
      "street_address",
      "street_address_line_2",
      "pincode"
      ];
      const csvContent = headers.join(",");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "companies.csv");
    }
    setIsExportDialogVisible(false);
  };

  const exportContactsToCSV = async () => {
    try {
      const response = await axios.get(`/api/v1/all-contacts-for-export/`);
      const data = response.data.results || [];
      const headers = ["first_name", "last_name", "email", "phone_number", "job_title", "company_name", "status", "department_name", "related_person_name"];
      const csvContent = convertToCSV(data, headers);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "contacts.csv");
    } catch (error) {
      console.error("Error exporting contacts:", error);
      const headers = ["first_name", "last_name", "email", "phone_number", "job_title", "company_name", "status", "department_name", "related_person_name"];
      const csvContent = headers.join(",");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "contacts.csv");
    }
    setIsExportDialogVisible(false);
  };

const validPaths = [
  "/allactive-jobs",
  "/allactive-candidates",
  "/contacts-allactive",
  "/companies-allactive",
];

const menuAddOptions = [
  ...(validPaths.includes(location.pathname)
    ? [
        {
          name: "Add Current Stakeholder",
          code: "EM-NE",
          action: () => {
            if (location.pathname === "/allactive-jobs") {
              dispatch(setJobSidebarVisible(true));
            } else if (location.pathname === "/allactive-candidates") {
              dispatch(setCandidateSidebarVisible(true));
            } else if (location.pathname === "/contacts-allactive") {
              dispatch(setContactSidebarVisible(true));
            } else if (location.pathname === "/companies-allactive") {
              dispatch(setCompanySidebarVisible(true));
            }
          },
        },
      ]
    : []),
  {
    name: "Parse bulk resumes",
    code: "EM-SE",
    action: () => navigate("/import-bulkresume"),
  },
   ...(SHOW_IMPORT ? [{
    name: "Import stakeholder from CSV / Excel",
    code: "EM-JO",
    subItems: [
      { name: "Candidates", code: "EM-JO-AL", action: () => navigate("/importfromcsv-candidates") },
      { name: "Jobs", code: "EM-JO-SE", action: () => navigate("/importfromcsv-jobs") },
      { name: "Companies", code: "EM-JO-SE", action: () => navigate("/importfromcsv-companies") },
      { name: "Contacts", code: "EM-JO-SE", action: () => navigate("/importfromcsv-contacts") },
    ],
  }] : []),
  ...(SHOW_IMPORT ? [{
    name: "Export stakeholder from CSV / Excel",
    code: "EM-EX",
    action: () => setIsExportDialogVisible(true),
    subItems: [
      { name: "Candidates", code: "EM-JO-AL", action: exportCandidatesToCSV },
      { name: "Jobs", code: "EM-JO-SE", action: exportJobsToCSV },
      { name: "Companies", code: "EM-JO-SE", action: exportCompaniesToCSV },
      { name: "Contacts", code: "EM-JO-SE", action: exportContactsToCSV },
    ],
  },
] : []),
];

  const handleSelectChange = (e) => {
    const selectedOption = e.value;
    setSelectedAddMenu(selectedOption);
    if (selectedOption && selectedOption.action) {
      selectedOption.action();
    }
  };

  const renderHeader = () => (
    <span className="ql-formats">
      <button className="ql-bold" aria-label="Bold"></button>
      <button className="ql-italic" aria-label="Italic"></button>
      <button className="ql-underline" aria-label="Underline"></button>
    </span>
  );

  const handlePrimarySkillsChange = (selectedOptions) => {
    setSelectedPrimarySkills(selectedOptions ? selectedOptions.map((option) => option.value) : []);
  };

  const updateAddress = () => {
    const addressParts = [
      street1,
      street2,
      selectedCity?.name,
      selectedState?.name,
      selectedCountry?.name,
      postalCode,
    ].filter((part) => part);
    setAddress(addressParts.join(", "));
  };

  const resetJobForm = () => {
    setJobId("");
    setJobTitle("");
    setSelectedCompany(null);
    setSelectedPerson(null);
    setExperience(null);
    setJobLocation(null);
    setJobStartDate(null);
    setJobEndDate(null);
    setSelectedPrimarySkills([]);
    setWorkplaceType("");
    setUserIds("");
    setSelectedCategoryKey(null);
    setSelectedGroupKey(null);
    setDescription("");
  };

  const resetCandidateForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhoneNumber("");
    setJobTitle("");
    setCandidateCompany("");
    setSelectedCity(null);
    setAvailabilityDate(null);
    setResumeAttachment(null);
    setSelectedPrimarySkills([]);
    setSelectedCategoryKey(null);
    setSelectedGroupKey(null);
    setUserIds("");
    setRelocation(false);
    setIsPrivate(false);
  };

  const resetContactForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhoneNumber("");
    setJobTitle("");
    setSelectedCompany(null);
    setSelectedDepartment(null);
    setRelatedPerson(null);
    setAddress("");
    setSelectedCategoryKey(null);
    setSelectedGroupKey(null);
    setUserIds("");
    setIsPrivate(false);
  };

  const resetCompanyForm = () => {
    setCompanyName("");
    setWebsite("");
    setCompanyEmail("");
    setCompanyPhone("");
    setAddress("");
    setYearFounded(null);
    setSpecialties("");
    setIndustry(null);
    setCompanySize(null);
    setOverview("");
    setSelectedCategoryKey(null);
    setSelectedGroupKey(null);
    setUserIds("");
    setIsPrivate(false);
  };

  const resetAddressForm = () => {
    setStreet1("");
    setStreet2("");
    setSelectedCity(null);
    setSelectedState(null);
    setSelectedCountry(null);
    setPostalCode("");
    setSelectedLabel(null);
  };

  return (
    <React.Fragment>
      <div>
        <Container fluid={true}>
          <Row>
            <Col lg={12}>
              <Tooltip target=".addbtn" content="Add" position="right" style={{ marginBottom: "5px" }} />
              <div className="addbtn">
                <CascadeSelect
                  onChange={handleSelectChange}
                  options={menuAddOptions}
                  optionLabel="name"
                  optionGroupLabel="name"
                  optionGroupChildren={["subItems"]}
                  className="addcus-cassel"
                  dropdownIcon={<PlusIcon className="custom-plus-icon" />}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Export Dialog */}
      <Dialog
        header="Export Stakeholders"
        visible={isExportDialogVisible}
        style={{ width: "30vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        onHide={() => setIsExportDialogVisible(false)}
      >
        <div className="card">
          {/* <Row>
            {menuAddOptions
              .find((option) => option.code === "EM-EX")
              .subItems.map((item) => (
                <Col lg={6} key={item.code} className="mb-3">
                  <Button
                    label={item.name}
                    className="w-full p-button-outlined"
                    onClick={item.action}
                  />
                </Col>
              ))}
          </Row> */}
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default AddMenu;